export const DE = 'de'
export const EN = 'en'
export const NL = 'nl'
export const FR = 'fr'

// Sprachen der Dashboard-Oberfläche (use-i18n, Funnel, Nutzerprofil,
// Tryout-HeaderHint). Das Dashboard selbst ist nur auf de und en übersetzt.
const languages = [DE, EN]

// Sprachen, in denen ein Assessment starten kann. Entspricht genau dem, was
// die Talent-App (aivy-universal-app, src/utils/languages.js) akzeptiert.
export const ASSESSMENT_LANGUAGES = [DE, EN, NL, FR]

const TRANSLATION_LOCATION = 'constants.languages.'

export const getAllLanguages = () => {
  // [ key, value ]
  return languages.map((id) => [id, TRANSLATION_LOCATION + id])
}

export const getAssessmentLanguages = () => {
  // [ key, value ]
  return ASSESSMENT_LANGUAGES.map((id) => [id, TRANSLATION_LOCATION + id])
}

export const isLanguageAvailable = (language) => {
  return languages.includes(language)
}

export const isAssessmentLanguage = (language) => {
  return ASSESSMENT_LANGUAGES.includes(language)
}

export const getLanguage = (id) => {
  return TRANSLATION_LOCATION + id
}
